import { debounce } from './utils.js'

export const initMegamenu = () => {
    // @ vars --------------------------------------------------
    const toolbar_toggle = document.querySelector('.toolbar__toggle')
    const megamenu__nav = document.querySelector('.megamenu__nav')
    const utilmenu__nav = document.querySelector('.utilmenu__nav')
    const li_level1_first = document.querySelector('.megamenu__li--level-1')
    const li_level1_items = document.querySelectorAll('.megamenu__li--level-1')
    const ul_level2_items = document.querySelectorAll('.megamenu__ul--level-2')

    // @ checks --------------------------------------------------
    if (!li_level1_first || ul_level2_items.length === 0) {
        console.warn('Megamenu elements not found!')
        return
    }

    const calcMegamenuLayout = () => {
        const paddingLeft = window.innerWidth >= 1024 ? `${li_level1_first.getBoundingClientRect().left}px` : 0

        ul_level2_items.forEach((ul) => {
            ul.style.paddingLeft = paddingLeft
        })
    }

    // @ events --------------------------------------------------
    window.addEventListener('resize', debounce(calcMegamenuLayout, 50))

    toolbar_toggle.addEventListener('click', (e) => {
        e.stopPropagation()
        toolbar_toggle.classList.toggle('toolbar__toggle--is-open')
        megamenu__nav.classList.toggle('megamenu__nav--is-open')
        utilmenu__nav.classList.toggle('utilmenu__nav--is-open')
    })

    li_level1_items.forEach((item) => {
        item.addEventListener('pointerenter', (e) => {
            if (e.pointerType === 'mouse') {
                item.classList.add('is-open')
                document.body.classList.add('no-scroll')
            }
        })

        item.addEventListener('pointerleave', (e) => {
            if (e.pointerType === 'mouse') {
                item.classList.remove('is-open')
                document.body.classList.remove('no-scroll')
            }
        })

        item.addEventListener('click', (e) => {
            e.stopPropagation()

            const li_open = document.querySelector('li.is-open')

            if (li_open && li_open !== item) {
                li_open.classList.remove('is-open')
            }

            item.classList.toggle('is-open')
            document.body.classList.toggle('no-scroll')
        })
    })

    document.addEventListener('click', (e) => {
        if (e.target.closest('.megamenu__li, .utilmenu__li') === null) {
            if (toolbar_toggle.classList.contains('toolbar__toggle--is-open')) {
                toolbar_toggle.classList.remove('toolbar__toggle--is-open')
                megamenu__nav.classList.remove('megamenu__nav--is-open')
                utilmenu__nav.classList.remove('utilmenu__nav--is-open')
            }
            const li_open = document.querySelector('li.is-open')

            if (li_open) {
                li_open.classList.remove('is-open')
                document.body.classList.remove('no-scroll')
            }
        }
    })

    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
            document.body.classList.remove('no-scroll')

            const li_open = document.querySelector('li.is-open')

            if (li_open) {
                li_open.classList.remove('is-open')
                document.body.classList.remove('no-scroll')
            }
        }
    })

    // @ init --------------------------------------------------
    calcMegamenuLayout()
}
